var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SdsBadge',{staticClass:"super-bonus-badge",attrs:{"size":_vm.size}},[_c('span',{staticClass:"super-bonus-badge__number",class:{
            'super-bonus-badge__number--md': _vm.size === 'md',
            'super-bonus-badge__number--lg': _vm.size === 'lg',
        }},[_vm._v(" "+_vm._s(_vm.percentage)+"% ")])])}
var staticRenderFns = []

export { render, staticRenderFns }